import HmsStatusTag from 'components/HmsStatusTag';
import SelectColumn from 'components/SelectColumn';
import { useMemo } from 'react';
import { getRegStatusOfSeasonPlayerRegistration, getStatusColor } from 'utils/status';

const RegistrationStatusColumn = ({ record, isAdmin, canEdit, onRegistrationStatusChange }) => {
  const currentStatus = getRegStatusOfSeasonPlayerRegistration(record);
  const onChangeAsync = useMemo(() => (newStatus) => onRegistrationStatusChange(record, newStatus), [record, onRegistrationStatusChange]);
  
  if (isAdmin && canEdit) {
    const backgroundColor = getStatusColor(currentStatus, 'SeasonPlayerRegistration') === 'green' ? '#f6ffed' : 
                          getStatusColor(currentStatus, 'SeasonPlayerRegistration') === 'orange' ? '#fff7e6' : 'transparent';
    const textColor = currentStatus === 'CONFIRMED' ? '#52c41a' : '#fa8c16';
    
    return (
      <SelectColumn
        value={currentStatus}
        onChangeAsync={onChangeAsync}
        options={[
          { value: 'NOT_CONFIRMED', label: 'NOT CONFIRMED', style: { color: '#fa8c16', fontWeight: '400' } },
          { value: 'CONFIRMED', label: 'CONFIRMED', style: { color: '#52c41a', fontWeight: '400' } },
        ]}
        style={{ width: '100%', backgroundColor: backgroundColor, '--select-color': textColor }}
        className="registration-status-select"
        dropdownStyle={{ zIndex: 1000 }}
        size="small"
      />
    );
  }
  
  return <HmsStatusTag status={currentStatus} entity="SeasonPlayerRegistration" />;
};

export default RegistrationStatusColumn;
